import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DoneIcon from "@mui/icons-material/Done";
import AddIcon from "@mui/icons-material/Add";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import "./salaryInfo.css";

const SalaryInfo = (props) => {
  const user = props.user ? props.user : null;
  const Employee = props.Employee;
  const [disableSend, setdisableSend] = useState(false);
  const [toggleEditSalary, settoggleEditSalary] = useState(false);
  const [salary, setSalary] = useState(Employee ? Employee.salary : "");
  const [openProjInc, setopenProjInc] = useState(false);
  const [projectInc, setProjectInc] = useState([]);
  const [retainerInc, setRetainerInc] = useState([]);

  const [projectIncData, setprojectIncData] = useState({
    increments: "",
    projectname: "",
    incDate: "",
  });
  const [RelaventProjects, setRelaventProjects] = useState([]);

  const handleProjectIncData = (e) => {
    const { name, value } = e.target;
    setprojectIncData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const SendProjectIncData = async () => {
    setdisableSend(true);
    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/addprojectincrement", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: Employee.email,
          name: Employee.name,
          projectName: projectIncData.projectname,
          increment: parseInt(projectIncData.increments, 10),
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setdisableSend(false);
        alert("Data Uploaded Succesfully");
        fetchData();
      } else {
        setdisableSend(false);
        throw new Error(data.message);
      }
    } catch (error) {
      setdisableSend(false);
      alert("Could not add Data");
    }
  };

  useEffect(() => {
    const fetchRetainerIncrements = async () => {
      try {
        const response = await fetch(
          `https://hr-backend-72v1.onrender.com/retainer-increments?email=${Employee.email}`
        );
        const data = await response.json();
        setRetainerInc(data);
      } catch (error) {
        // ignore
      }
    };

    if (Employee) {
      fetchRetainerIncrements();
    }
  }, [Employee]);

  useEffect(() => {
    if (user.role == "HR" || user.role == "Executive") {
      const fetchRelaventProjects = async () => {
        try {
          const response = await fetch(
            `https://hr-backend-72v1.onrender.com/api/relaventprojects/${Employee.email}`
          );
          if (!response.ok) throw new Error("Failed to fetch projects");
          const data = await response.json();
          setRelaventProjects(data);
        } catch (error) {
          setRelaventProjects([]);
        }
      };
      fetchRelaventProjects();
    }
  }, [user]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://hr-backend-72v1.onrender.com/getrelaventincrements?email=${Employee.email}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setProjectInc(
        data.map((inc) => [inc.increment, inc.projectName, inc.incrementDate])
      ); // Update projectInc with latest data
      setopenProjInc(false);
    } catch (error) {
      console.error("Error:");
    }
  };

  useEffect(() => {
    if (Employee) {
      fetchData();
    }
  }, [Employee]);

  const isHrOrExec = user && (user.role === "HR" || user.role === "Executive");
  const projCount = Array.isArray(projectInc) ? projectInc.length : 0;
  const retCount = Array.isArray(retainerInc) ? retainerInc.length : 0;

  return (
    <div className="slWrap">
      <header className="slHeader">
        <h1 className="slTitle">Salary</h1>
        <p className="slSubtitle">Compensation, increments and allowances</p>
      </header>

      {/* stat row */}
      <div className="slStatRow">
        <section className="slStat slStat--feature">
          <div className="slStatWatermark">
            <PaymentsOutlinedIcon sx={{ fontSize: 104 }} />
          </div>
          {isHrOrExec && (
            <button
              className="slEditBtn"
              onClick={() =>
                toggleEditSalary
                  ? props.inputEditHandler(
                      Employee.email,
                      "salary",
                      salary,
                      settoggleEditSalary
                    )
                  : settoggleEditSalary(true)
              }
              aria-label={toggleEditSalary ? "Save" : "Edit"}
            >
              {toggleEditSalary ? (
                <DoneIcon sx={{ fontSize: 18 }} />
              ) : (
                <EditOutlinedIcon sx={{ fontSize: 16 }} />
              )}
            </button>
          )}
          <div className="slStatLabel slStatLabel--feature">Total Salary</div>
          <div className="slFeatureValueRow">
            {!toggleEditSalary ? (
              <span className="slFeatureValue">{salary !== "" && salary != null ? salary : "-"}</span>
            ) : (
              <input
                className="slSalInput"
                type="text"
                placeholder="Enter salary"
                maxLength="50"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
            )}
          </div>
        </section>

        <section className="slStat">
          <div className="slStatTop">
            <span className="slStatLabel">Project Increments</span>
            <TrendingUpIcon className="slStatIcon" sx={{ fontSize: 20 }} />
          </div>
          <div className="slStatValue">{projCount}</div>
          <div className="slStatCaption">
            {projCount > 0 ? `${projCount} recorded` : "None recorded yet"}
          </div>
        </section>

        <section className="slStat">
          <div className="slStatTop">
            <span className="slStatLabel">Retainer Allowance</span>
            <AttachMoneyIcon className="slStatIcon" sx={{ fontSize: 20 }} />
          </div>
          <div className="slStatValue">{retCount}</div>
          <div className="slStatCaption">
            {retCount > 0 ? `${retCount} recorded` : "None recorded yet"}
          </div>
        </section>
      </div>

      {/* Project Increments panel */}
      <section className="slPanel">
        <header className="slPanelHead">
          <span className="slPanelIcon">
            <TrendingUpIcon sx={{ fontSize: 17 }} />
          </span>
          <h3 className="slPanelTitle">Project Increments</h3>
          {isHrOrExec && (
            <button
              className="slAddBtn"
              onClick={() => setopenProjInc(!openProjInc)}
            >
              <AddIcon sx={{ fontSize: 16 }} />
              Add Project Increment
            </button>
          )}
        </header>
        <div className="slTableHead slTableHead--proj">
          <span>Increment</span>
          <span>Project Name</span>
          <span>Increment Date</span>
        </div>

        {openProjInc && (
          <div className="slAddForm">
            <input
              className="slInput"
              type="number"
              name="increments"
              value={projectIncData.increments}
              onChange={handleProjectIncData}
              placeholder="Enter Increment"
            />
            <Autocomplete
              sx={{ width: "100%" }}
              options={RelaventProjects}
              getOptionLabel={(option) => (option ? option : "")}
              onChange={(event, newValue) => {
                setprojectIncData((prev) => ({
                  ...prev,
                  projectname: newValue,
                }));
              }}
              renderInput={(params) => (
                <TextField {...params} label="Projects" variant="outlined" size="small" />
              )}
            />
            <button
              disabled={disableSend}
              className="slSendBtn"
              onClick={SendProjectIncData}
            >
              Send
            </button>
          </div>
        )}

        {projCount > 0 ? (
          projectInc.map((item, index) => (
            <div className="slRow slRow--proj" key={index}>
              <span className="slRowStrong">{item[0]}</span>
              <span>{item[1]}</span>
              <span className="slRowMuted">{item[2].split("T")[0]}</span>
            </div>
          ))
        ) : (
          <div className="slEmpty">
            <span className="slEmptyIcon">
              <TrendingUpIcon sx={{ fontSize: 24 }} />
            </span>
            <div>
              <div className="slEmptyTitle">No project increments yet</div>
              <div className="slEmptySub">
                Increments appear here once added by your manager.
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Retainer Allowance panel */}
      <section className="slPanel">
        <header className="slPanelHead">
          <span className="slPanelIcon">
            <AttachMoneyIcon sx={{ fontSize: 17 }} />
          </span>
          <h3 className="slPanelTitle">Retainer Allowance</h3>
        </header>
        <div className="slTableHead slTableHead--ret">
          <span>Increment</span>
          <span>Client Name</span>
          <span>Increment Date</span>
        </div>

        {retCount > 0 ? (
          retainerInc.map((item, index) => (
            <div className="slRow slRow--ret" key={index}>
              <span className="slRowStrong">{item.increment}</span>
              <span>{item.clientName}</span>
              <span className="slRowMuted">
                {new Date(item.incrementDate).toLocaleDateString()}
              </span>
            </div>
          ))
        ) : (
          <div className="slEmpty">
            <span className="slEmptyIcon">
              <AttachMoneyIcon sx={{ fontSize: 24 }} />
            </span>
            <div>
              <div className="slEmptyTitle">No retainer increments yet</div>
              <div className="slEmptySub">
                Client retainer allowances will be listed here.
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default SalaryInfo;
